import { $Q } from '../utils/querySelector';

/**
 *
 * @param {string} buttonSelector - id or class selector for the button
 * @param {string} parentSelector - id or class of the input parent, where the input should be looked up from
 */
export const passwordRevealer = (buttonSelector, parentSelector) => {
  const button = $Q(buttonSelector);

  if (button) {
    button.addEventListener('click', function (event) {
      const hiddenImage = this.dataset.passwordHidden;
      const shownImage = this.dataset.passwordShown;
      const imgElement = $Q('img', this);

      const input = $Q(`${parentSelector} input`);

      if (input.type === 'password') {
        input.type = 'text';
        imgElement.src = shownImage;
      } else {
        input.type = 'password';
        imgElement.src = hiddenImage;
      }
    });
  }
};
